<template>
  <div class="row mt-5 b-form__container_type_flex b-form__row_type_flex-end">
    <div class="col-3">
      <div>
        <label>{{$t('CONTENT.contract.period')}}:</label>
        <datepicker v-bind:class="{ 'b-datepicker__error': isFieldWithError('startDate', startDate) }" class="b-datepicker" v-model="startDate" :formatter="datepickerFormat" :disabled-date="maxDateForStartDateFn"></datepicker>
      </div>
    </div>
    <div class="col-3">
      <div>
        <datepicker v-bind:class="{ 'b-datepicker__error': isFieldWithError('endDate', endDate) }" class="b-datepicker" v-model="endDate" :formatter="datepickerFormat" :disabled-date="minDateForEndDateFn"></datepicker>
      </div>
    </div>
    <div class="col-4">
      <label>{{$t('CONTENT.sum')}}:</label>
      <numeric v-bind:class="{ 'b-numeric__error': isFieldWithError('sum', sum) }" class="b-numeric" controls :min="0" :max="1000000000000" required="false" v-model="sum"></numeric>
    </div>
    <div class="mb-2 mr-2">
      {{systemCurrencyCode}}
    </div>
    <button type="button" class="b-btn b-btn_border_none" @click="deletePeriodSpendingsItem(periodSpendingsItemIndex)" v-if="periodSpendingsLength > 1">
      <dynamic-icon class="b-btn__icon" icon="close"></dynamic-icon>
    </button>
  </div>
</template>

<script>
	import dateConverter from "../../../utils/converters/date.converter";
  import datepickerFormat from '@/mixins/datepickerFormat.mixin';

	export default {
		props: {
			periodSpendingsItem: {
				type: Object
      },
			periodSpendingsItemIndex: {
				type: Number
      },
			periodSpendingsLength: {
				type: Number,
      },
      systemCurrencyCode: {
			  type: String,
      },
      validationErrors: {
        type: Array
      }
    },
    mixins: [datepickerFormat],
		data() {
			return {
        maxDateForStartDate: null,
        minDateForEndDate: null,
			}
		},
    computed: {
			startDate: {
				get() {
					if (this.periodSpendingsItem.startDate === null) {
						return null;
					} else {
						return dateConverter.convertToDate(this.periodSpendingsItem.startDate);
					}
				},
				set(newVal) {
				  if(newVal !== null) {
            let startDateObject = newVal;
            this.minDateForEndDate = startDateObject;
            this.periodSpendingsItem.startDate = dateConverter.convertToString(startDateObject);
          } else {
            this.periodSpendingsItem.startDate = null;
          }
        }
			},
			endDate: {
				get() {
					if (this.periodSpendingsItem.endDate === null) {
						return null;
					} else {
						return dateConverter.convertToDate(this.periodSpendingsItem.endDate);
					}
				},
				set(newVal) {
          if(newVal !== null) {
            let endDateObject = newVal;
            this.maxDateForStartDate = endDateObject;
            this.periodSpendingsItem.endDate = dateConverter.convertToString(endDateObject);
          } else {
            this.periodSpendingsItem.endDate = null;
          }
        }
			},
			sum: {
				get() {
				  if (this.periodSpendingsItem.sum !== null) {
            return this.periodSpendingsItem.sum;
          }
				},
				set(newVal) {
          this.periodSpendingsItem.sum = newVal;
        }
			},
    },
    methods: {
      maxDateForStartDateFn(date) {
        if(this.maxDateForStartDate !== null) {
          return date > this.maxDateForStartDate;
        }
      },
      minDateForEndDateFn(date) {
        if(this.minDateForEndDate !== null) {
          return date < this.minDateForEndDate;
        }
      },
			deletePeriodSpendingsItem(itemIndex) {
				this.$emit('onDeletePeriodSpending', itemIndex);
      },
      isFieldWithError(field, value) {
        return !value && this.validationErrors && this.validationErrors.includes(field);
      }
    }
	}
</script>
